import { nanoid } from 'nanoid';

import { WorkflowNodeType } from '../constants';
import { FlowNodeRegistry } from '../../typings';
import iconFeishuNotification from '../../assets/icon-msg.png';
import { formMeta } from './feishu-notification-meta';

// 定义推送飞书通知节点注册信息
const FeishuNotificationNodeRegistry: FlowNodeRegistry = {
  type: WorkflowNodeType.FeishuNotification,
  label: '推送飞书通知',
  meta: {},
  info: {
    icon: iconFeishuNotification,
    description: '推送飞书通知',
  },
  formMeta,
  onAdd(ctx) {
    return {
      id: `${WorkflowNodeType.FeishuNotification}_${nanoid(5)}`,
      type: WorkflowNodeType.FeishuNotification,
      data: {
        title: '推送飞书通知',
      },
    };
  },
};

export default FeishuNotificationNodeRegistry;
